<template>
  <div class="buttons">
    <KakaoButton
      btnLabel="카카오로 가입"
      @kakaoSignUp="kakaoSignUp"
      @kakaoSignIn="kakaoSignIn"
    />
    <v-btn
      color="primary"
      x-large
      depressed
      block
      rounded
      @click="$emit('clickPhoneSignUp')"
    >
      전화번호로 가입
    </v-btn>
    <div class="link-group">
      <div>
        <v-label>이미 가입 하셨나요?</v-label>
      </div>
      <div>
        <v-btn
          mini
          depressed
          rounded
          @click="$router.push({ path: '/login' }).catch(() => {})"
        >
          로그인 하기</v-btn
        >
      </div>
    </div>
  </div>
</template>
<script>
import KakaoButton from "@/_bayer/kakaoCommon/KakaoButton.vue";
export default {
  components: { KakaoButton },
  methods: {
    kakaoSignIn(e) {
      console.log('Entry ', e);
      this.$emit('kakaoSignIn', e)
    },
    kakaoSignUp(e) {
      console.log('Entry kakaoSignUp ', e);
      this.$emit('kakaoSignUp', e)
    }
  },
};
</script>
<style lang="scss"></style>